import React  from 'react'
import Image from './Image'
import Distance from './Distance'
import { DifficultText, DifficultIcon } from './Difficult'
import TravelTime from './TravelTime'
import Link from './Link'
import {useRouteImage} from "../api"
import { reverse } from '../urls'

import DistanceIcon from '../icons/hiker.svg'
import TimeIcon from '../icons/clock.svg'
import StageIcon from '../icons/calendar.svg'


import {
  TRAIL_LENGTH,
  TRAIL_DURATION,
  TRAIL_TRAVEL_TIME,
  TRAIL_STAGES_NUMBER,
  STAGES
} from '../trans'


const RouteCard = (props) => {

  const { title, image, length, difficult, time, route_id, trail_count, className="" } = props

  return (
    <Link to={{ pathname: reverse(route_id), hash: '' }} className={"pwa__route__card  " + className}>
      <h2>{ title }</h2>

      <ul className="pwa__route__stats">
        <li className="pwa__route__stat">
          <DistanceIcon title={TRAIL_LENGTH}/>
          <Distance value={length}/>
        </li>

        { (trail_count == 1) && (
          <li className="pwa__route__stat">
            <TimeIcon title={TRAIL_TRAVEL_TIME} />
            <TravelTime value={time}/>
          </li>
        )}

        { (trail_count > 1) && (
          <li className="pwa__route__stat">
            <StageIcon title={TRAIL_STAGES_NUMBER}/>
            <div>{trail_count}&nbsp;{STAGES}</div>
          </li>
        )}

        <li className="pwa__route__stat">
          <DifficultIcon value={difficult}/>
          <div>
            <DifficultText value={difficult}/>
          </div>
        </li>
      </ul>

      { image && <Image src={image.small} /> }

    </Link>
  )
}

export default RouteCard;
